import React from "react";
import clsx from "clsx";
import { isEmpty } from "lodash";
import { Button } from "../Button";
import "./formatters.scss";

export const textFormatter = (cell) => (
  <div title={cell} className="Uic-formatters-ellipsis">
    {cell}
  </div>
);

export const linkFormatter = (cell, row, rowIndex, { onClick }) => (
  <div className="Uic-formatters-ellipsis">
    <Button
      title={cell}
      variant="link"
      className="Uic-formatters-linkFormatter"
      onClick={(event) => {
        event.stopPropagation();
        onClick(row);
      }}
    >
      {cell}
    </Button>
  </div>
);

function TextPill(props) {
  const { children } = props; // eslint-disable-line react/prop-types
  return <span className="Uic-formatters-pill">{children}</span>;
}

export const multiTextFormatter = (cell) => {
  if (isEmpty(cell)) {
    return null;
  }

  return (
    <div
      className={clsx("Uic-formatters-multiText", "Uic-formatters-ellipsis")}
      title={cell.join(", ")}
    >
      {cell.map((item, index) => (
        <TextPill key={index}>{item}</TextPill> // eslint-disable-line react/no-array-index-key
      ))}
    </div>
  );
};
